import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  HStack,
  Text,
  Box,
} from "@chakra-ui/react";
import ParseStatusBadge from "./ParseStatusBadge";
import {
  getCandidateDisplayName,
  getResumeSkills,
  formatDateTime,
  formatExperience,
} from "../utils/resumeHelpers";

const ResumeTable = ({ rows = [], onView, onDownload }) => {
  if (!rows.length) {
    return (
      <Box py={8} textAlign="center">
        <Text color="gray.500">No resumes found. Upload first resume.</Text>
      </Box>
    );
  }

  return (
    <Table size="sm" variant="simple">
      <Thead>
        <Tr>
          <Th>Candidate Name</Th>
          <Th>Skills</Th>
          <Th>Experience</Th>
          <Th>Location</Th>
          <Th>Current Company</Th>
          <Th>Status</Th>
          <Th>Uploaded Date</Th>
          <Th>Actions</Th>
        </Tr>
      </Thead>
      <Tbody>
        {rows.map((resume) => (
          <Tr key={resume._id}>
            <Td>{getCandidateDisplayName(resume)}</Td>
            <Td>{getResumeSkills(resume).slice(0, 3).join(", ") || "-"}</Td>
            <Td>{formatExperience(resume.experienceYears)}</Td>
            <Td>
              {resume.currentLocation || resume.parsedData?.location || "-"}
            </Td>
            <Td>
              {resume.currentCompany ||
                resume.parsedData?.currentCompany ||
                "-"}
            </Td>
            <Td>
              <ParseStatusBadge status={resume.parsingStatus} />
            </Td>
            <Td>{formatDateTime(resume.uploadedAt)}</Td>
            <Td>
              <HStack>
                <Button size="xs" onClick={() => onView?.(resume)}>
                  View
                </Button>
                <Button
                  size="xs"
                  variant="outline"
                  onClick={() => onDownload?.(resume)}
                >
                  Download
                </Button>
              </HStack>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default ResumeTable;
